module.exports = __webpack_public_path__ + "static/media/enterprise-ireland.c2e74405.png";